import axios from "axios";
import { takeLatest, call, put, select, all } from "redux-saga/effects";
import { createAction } from "redux-actions";
import { queryParams } from "../../../utils/queryParams.js";
import { showToast } from "../../../utils/showToast.js";

export const FETCH_MODAL_FILTERS_SUCCESS = "saga/FETCH_MODAL_FILTERS_SUCCESS";
export const FETCH_CURRENT_USER_SUCCESS = "saga/FETCH_CURRENT_USER_SUCCESS";
export const FETCH_GOAL_BY_TYPE_SUCCESS = "saga/FETCH_GOAL_BY_TYPE_SUCCESS";
export const FETCH_UPDATE_GOAL_SUCCESS = "saga/FETCH_UPDATE_GOAL_SUCCESS";
export const SET_MODAL_FILTER = "saga/SET_MODAL_FILTER";
export const FETCH_MODAL_FILTERS = "saga/FETCH_MODAL_FILTERS";
export const FETCH_CURRENT_USER = "saga/FETCH_CURRENT_USER";
export const UPDATE_TOP_GOALS = "saga/UPDATE_TOP_GOALS";
export const UPDATE_GOAL_AS_VALUE = "saga/UPDATE_GOAL_AS_VALUE";
export const UPLOAD_GOALS = "saga/goals/UPLOAD_GOALS";
export const UPDATE_GOAL = "saga/UPDATE_GOAL";
export const UPDATE_MODULE_VIEW = "saga/UPDATE_MODULE_VIEW";
export const UPDATE_DATE = "saga/UPDATE_DATE";
export const UPDATE_VIEW = "saga/UPDATE_VIEW";
export const UPDATE_MODAL_FILTER = "saga/UPDATE_MODAL_FILTER";
export const SET_MODAL_FILTERS_LOADING = "saga/SET_MODAL_FILTERS_LOADING";
export const SET_TOP_GOALS_LOADING = "saga/SET_TOP_GOALS_LOADING";
export const SET_VISIBLE_COLUMNS = "saga/SET_VISIBLE_COLUMNS";
export const SET_MODAL_LOADING = "saga/SET_MODAL_LOADING";
export const SET_GOALS_LOADING = "saga/SET_GOALS_LOADING";
export const SET_LOADING = "saga/SET_LOADING";
export const SET_DATE = "saga/SET_DATE";
export const SET_STATUS = "saga/SET_STATUS";
export const RESET_FILTERS = "saga/RESET_FILTERS";
export const ADD_GOAL = "saga/ADD_GOAL";
export const SET_ERROR = "saga/SET_ERROR";

export const actionCreators = {
  fetchCurrentUser: createAction(FETCH_CURRENT_USER),
  createGoal: createAction(ADD_GOAL),
  getModalFilters: createAction(FETCH_MODAL_FILTERS),
  updateGoalAsValue: createAction(UPDATE_GOAL_AS_VALUE),
  updateModalFilter: createAction(UPDATE_MODAL_FILTER),
  updateModuleView: createAction(UPDATE_MODULE_VIEW),
  updateDate: createAction(UPDATE_DATE),
  updateGoal: createAction(UPDATE_GOAL),
  updateView: createAction(UPDATE_VIEW),
  uploadGoals: createAction(UPLOAD_GOALS),
  resetFilters: createAction(RESET_FILTERS)
};
export default function* watchGoals() {
  yield takeLatest(FETCH_CURRENT_USER, getCurrentUserData);
  yield takeLatest(UPDATE_GOAL, updateGoal);
  yield takeLatest(ADD_GOAL, addGoal);
  yield takeLatest(UPDATE_MODAL_FILTER, updateAddStaffModalFilters);
  yield takeLatest(UPDATE_GOAL_AS_VALUE, updateGoalAsValue);
  yield takeLatest(UPLOAD_GOALS, uploadGoals);
  yield takeLatest(UPDATE_MODULE_VIEW, updateModuleView);
  yield takeLatest([UPDATE_VIEW, UPDATE_DATE], fetchAllGoals);
  yield takeLatest(FETCH_MODAL_FILTERS, fetchAddStaffModalFilters);
}
const GOAL_TYPES = {
  store: ["attendance", "revenue", "memberships", "retention", "daily_pulse"],
  staff: ["revenue"]
};

const LOADING_FILTER_DEPENDENCIES = {
  divisions: ["districts", "stores", "goals", "staffs"],
  districts: ["stores", "goals", "staffs"],
  stores: ["goals", "staffs"],
  goals: ["staffs"]
};

const FILTER_PARAMS_BY_FILTER_NAME = {
  divisions: ["division_ids"],
  districts: ["division_ids", "districts_ids"],
  stores: ["division_ids", "districts_ids", "store_ids"],
  goals: ["division_ids", "districts_ids", "store_ids", "goal"]
};

export function* getCurrentUserData({ payload }) {
  const { short_url } = yield select((state) => state.commonReducer.commonProps);

  yield put({ type: FETCH_CURRENT_USER_SUCCESS, payload: { ...payload, short_url } });
  yield put({ type: SET_LOADING, payload: true });

  yield put({ type: SET_DATE, payload: payload.calendarEndDate });

  try {
    yield put({ type: SET_LOADING, payload: false });
    yield fetchAllGoals();
  } catch (error) {
    console.error(error);
  }
}

function* uploadGoals(data) {
  let { organization_id, apiPath } = yield getCommonApiParams();
  try {
    let res = yield call(axios.post, queryParams.apiVersion + `${apiPath}/upload`, {
      organization_id: organization_id.toString(),
      file: data.payload
    });
    if (res.status == 200) {
      showToast(res.data.message);
    }
  } catch (err) {
    console.log(err);
  }
}

export function* updateModuleView() {
  try {
    yield put({ type: SET_LOADING, payload: true });

    yield fetchAllGoals();

    yield put({ type: SET_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* fetchAllGoals() {
  try {
    yield put({ type: SET_TOP_GOALS_LOADING, payload: true });
    let { moduleView } = yield getCommonApiParams();

    yield put({ type: SET_VISIBLE_COLUMNS });

    const fetchAllGoalsSagas = GOAL_TYPES[moduleView].map((goal_type) =>
      fetchGoalsByType(goal_type)
    );

    yield all(fetchAllGoalsSagas);
    yield put({ type: UPDATE_TOP_GOALS });
    yield put({ type: SET_TOP_GOALS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* addGoal({ payload }) {
  try {
    const { goal, goalType } = payload;
    const { organization_id, short_url, date, view, apiPath, addStaffFilters } =
      yield getCommonApiParams();

    yield put({ type: SET_STATUS, payload: "pending" });

    let res = yield call(axios.post, queryParams.apiVersion + `${apiPath}`, {
      organization_id: organization_id.toString(),
      short_url,
      staff_goal: {
        change: Number(goal),
        date,
        view,
        goal_type: goalType,
        ...addStaffFilters
      }
    });

    if (res.status === 200) {
      yield fetchGoalsByType(payload.goalType, true);
      yield put({ type: SET_STATUS, payload: "success" });
    }
    if (res.status === 202) {
      showToast(res.data.message, 5000);
      yield put({ type: SET_STATUS, payload: "success" });
    }
  } catch (err) {
    console.log(err);
    if (err.response.status === 422) {
      yield put({ type: SET_ERROR, payload: err.response.data });
    }
  }
}

function* fetchAddStaffModalFilters({ payload }) {
  try {
    yield put({ type: SET_MODAL_LOADING, payload: true });
    const { short_url, date, apiPath } = yield getCommonApiParams();

    const { data } = yield call(axios.post, queryParams.apiVersion + `${apiPath}/get_filters`, {
      short_url,
      date,
      goal_type: payload.goalType
    });

    yield put({ type: FETCH_MODAL_FILTERS_SUCCESS, payload: data });

    yield put({ type: SET_MODAL_LOADING, payload: false });
  } catch (error) {
    console.error("Failed to fetch modal filters:", error);
  }
}

function* updateAddStaffModalFilters({ payload }) {
  try {
    const { filterName, goalType } = payload;
    let { short_url, date, apiPath, addStaffFilters } = yield getCommonApiParams();

    const dependentFilters = LOADING_FILTER_DEPENDENCIES[filterName];

    if (dependentFilters) {
      const params = {
        short_url,
        date,
        goal_type: goalType
      };

      const filterParams = FILTER_PARAMS_BY_FILTER_NAME[filterName] || [];

      for (const key of filterParams) {
        params[key] = addStaffFilters[key];
      }

      yield put({
        type: SET_MODAL_FILTERS_LOADING,
        payload: { filters: dependentFilters, isLoading: true }
      });

      const { data } = yield call(
        axios.post,
        queryParams.apiVersion + `${apiPath}/get_filters`,
        params
      );

      yield put({ type: FETCH_MODAL_FILTERS_SUCCESS, payload: data });
      yield put({
        type: SET_MODAL_FILTERS_LOADING,
        payload: { filters: dependentFilters, isLoading: false }
      });
    }
  } catch (err) {
    console.log(err);
  }
}

function* fetchGoalsByType(goal_type, singleUpdate) {
  let { organization_id, short_url, date, view, apiPath } = yield getCommonApiParams();

  const params = {
    organization_id,
    short_url,
    date,
    view
  };
  yield put({ type: SET_GOALS_LOADING, payload: { [goal_type]: true } });
  try {
    const { data } = yield call(axios.get, queryParams.apiVersion + apiPath, {
      params: { ...params, goal_type }
    });
    yield put({ type: FETCH_GOAL_BY_TYPE_SUCCESS, payload: data });

    if (singleUpdate) {
      yield put({ type: UPDATE_TOP_GOALS });
    }

    yield put({ type: SET_GOALS_LOADING, payload: { [goal_type]: false } });
  } catch (error) {
    console.error(error);
  }
}

function* updateGoal({ payload }) {
  yield put({ type: SET_TOP_GOALS_LOADING, payload: true });
  let { apiPath, short_url } = yield getCommonApiParams();

  try {
    let queryString =
      "?change=" +
      payload.value +
      "&active=" +
      payload.active +
      "&goal_type=" +
      payload.goal_type +
      "&use_expected_value=false" +
      "&short_url=" +
      short_url;

    if (payload.goal_store_id) {
      queryString += "&goal_store_id=" + payload.goal_store_id;
    }
    const url = queryParams.apiVersion + apiPath + "/" + payload.id + queryString;
    const { data } = yield call(axios.put, url);
    console.log("data", data);
    yield put({
      type: FETCH_UPDATE_GOAL_SUCCESS,
      payload: { [payload.goal_type]: data }
    });

    yield put({ type: SET_TOP_GOALS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* updateGoalAsValue({ payload }) {
  yield put({ type: SET_TOP_GOALS_LOADING, payload: true });
  let { apiPath, short_url } = yield getCommonApiParams();
  try {
    let queryString =
      "?expected_value=" +
      payload.value +
      "&active=" +
      payload.active +
      "&goal_type=" +
      payload.goal_type +
      "&use_expected_value=true" +
      "&short_url=" +
      short_url;

    if (payload.goal_store_id) {
      queryString += "&goal_store_id=" + payload.goal_store_id;
    }
    const url = queryParams.apiVersion + apiPath + "/" + payload.id + queryString;
    const { data } = yield call(axios.put, url);

    yield put({
      type: FETCH_UPDATE_GOAL_SUCCESS,
      payload: { [payload.goal_type]: data }
    });

    yield put({ type: SET_TOP_GOALS_LOADING, payload: false });
  } catch (error) {
    console.error(error);
  }
}

function* getCommonApiParams() {
  const { organization_id, short_url } = yield select((state) => state.commonReducer.commonProps);

  let {
    selectedView,
    date,
    selectedModuleView,
    currentUser: { singleLocation },
    addStaffModal: {
      selectedFilters: { goals, staffs, divisions, districts, stores }
    }
  } = yield select((state) => state.newGoals);
  const baseFilters = {
    goal: goals[0]?.class_name,
    staff_uids: staffs?.map(({ staff_uid }) => staff_uid)
  };

  return {
    organization_id,
    short_url,
    date,
    view: selectedView.id,
    moduleView: selectedModuleView.id,
    apiPath: selectedModuleView.id === "store" ? "goals" : "staff_goals",
    addStaffFilters: {
      ...(singleLocation
        ? baseFilters
        : {
            ...baseFilters,
            division_ids: divisions?.map(({ id }) => id),
            districts_ids: districts?.map(({ id }) => id),
            store_ids: stores?.map(({ id }) => id)
          })
    }
  };
}
